export const camelToSentenceCase = (text: string) => {
  if (text.startsWith("intPk")) return text;
  const result = text.replace(/([A-Z])/g, " $1");
  return result.charAt(0).toUpperCase() + result.slice(1);
};
